(function($, undefined) {
	'use strict';
	var mapCtn;
    var isUnderSm = true;

	var initMap = function() {
		mapCtn.each(function(index) {
			var t = $(this);
			var id = t.closest('.map-com-outer-ctn').attr('data-id');
			var map;
			var geocoder;
			var marker;
			var address = t.closest('.map-com').find('.map-com-address').html();
			var panX = t.data('panX');
			var panY = t.data('panY');
			var panMinWidth = t.data('panMinWidth');

			if (address.length === 0) {
				return;
			}

            if ($(window).width() >= panMinWidth) {
                isUnderSm = false;
            }

			var mapOptions = {
				zoom: 16,
				disableDefaultUI: true,
			};

			geocoder = new google.maps.Geocoder();
			geocoder.geocode({
				'address': address
			}, function(results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					mapOptions.center = results[0].geometry.location;
					map = new google.maps.Map(document.getElementById('map-'+ id), mapOptions);
					// var newPanX = panX;
                    // var newPanY = panY;
                
	                // if (panX.substr(panX.length - 1) === '%') {
	                //     var percValueX = parseInt(panX.substr(0, (panX.length - 1)));
	                //     var mapWidth = parseInt(t.width());
	                //     newPanX = mapWidth / 100 * percValueX;
	                // }
	                
	                // if (panY.substr(panY.length - 1) === '%') {
	                //     var percValueY = parseInt(panY.substr(0, (panY.length - 1)));
	                //     var mapHeight = parseInt(t.height());
	                //     newPanY = mapHeight / 100 * percValueY;
	                // }
					// if (!isUnderSm) {
	                //     map.panBy(newPanX, newPanY);
	                // }

					marker = new google.maps.Marker({
						map: map,
						position: results[0].geometry.location,
						icon: t.attr('data-marker'),
						title: address,
					});
				}
			});
		});
	};

	var init = function() {
		mapCtn = $('.map-com-outer-ctn');

		if (mapCtn.length) {
			initMap();
		}
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

